/**
 * Normaliza a NFD y elimina acentos (tildes / diacríticos)
 */
export function removeAccents(text) {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Normaliza nombre de compañía y lo codifica
 * para uso en Business Central OData
 */
export function encodeBcCompanyName(name) {
  return encodeURIComponent(name.normalize("NFD"));
}
